// extracted by mini-css-extract-plugin
export default {"title":"index_title_1e2ai","title_mt":"index_title_mt_zYNJ4 index_title_1e2ai"};